module.exports = __webpack_public_path__ + "img/emo_07.fda727bc.png";